import { spatemByIdSelector } from '_store/spatem/selectors';
import { useLocalization } from '@fluent/react';
import { Box, Button, CardContent, CardHeader, IconButton } from '@material-ui/core';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import CloseIcon from '@material-ui/icons/Close';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import styles from '../Pmv/styles';
import SpatemRsusManage from './SpatemRsusManage';
import { SpatemCrudType } from './types';

const SpatemCrudLayout: FC<SpatemCrudType> = ({ id, onGoingBack, onClose, closeDialog }) => {
  const { l10n } = useLocalization();
  const classes = styles();
  const spatem = useSelector(spatemByIdSelector(id));

  return (
    <CardContent className={classes.cardContent}>
      <Box className={classes.box}>
        <Button
          variant="text"
          onClick={onGoingBack}
          size="small"
          className={classes.backBnt}
          startIcon={<ArrowBackIosIcon />}
        >
          {l10n.getString('back')}
        </Button>

        <IconButton className={classes.closeBnt} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>

      <CardHeader
        title={`${l10n.getString('forms-spatem-update-rsus')} ${spatem?.identifier ?? ''}`}
        className={classes.header}
        titleTypographyProps={{ variant: 'h6' }}
      />

      <SpatemRsusManage id={id} closeDialog={closeDialog} />
    </CardContent>
  );
};

export default React.memo(SpatemCrudLayout);
